// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-FW9c","header_logo":"Header_header_logo__+7Wns","header_title":"Header_header_title__pAwNe","header_subtitle":"Header_header_subtitle__NnZkT"};